import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { DateFormatPipe, StatusBadgePipe } from '../../../../shared/pipes';
import { SafetyTest } from '../../../../core/data-models/safety-test.model';
import { SafetyTestService } from '../../../../core/data-services/safety-test.service';
import { SafetyTestStatus } from '../../../../core/data-models/safety-test-status.model';

@Component({
  selector: 'app-safety-tests',
  standalone: true,
  imports: [CommonModule, DateFormatPipe, StatusBadgePipe],
  templateUrl: './safety-tests.component.html',
  styleUrls: ['./safety-tests.component.scss']
})
export class SafetyTestsComponent implements OnInit {
  // Inject SafetyTestService
  private safetyTestService = inject(SafetyTestService);

  // Signal-based state from service
  readonly safetyTests = this.safetyTestService.tests;
  readonly isLoading = this.safetyTestService.isLoading;

  // Computed stats from service
  readonly completedTests = this.safetyTestService.completedTests;
  readonly totalTests = this.safetyTestService.totalTests;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.safetyTestService.loadTests();
  }

  takeTest(test: SafetyTest): void {
    this.router.navigate(['/logbook/testing/safety', test.id, 'take']);
  }

  viewStudyGuide(test: SafetyTest): void {
    this.safetyTestService.viewStudyGuide(test.id);
  }

  viewReport(test: SafetyTest): void {
    this.router.navigate(['/logbook/testing/safety', test.id, 'report']);
  }

  getStatusText(status: SafetyTestStatus): string {
    return this.safetyTestService.getStatusText(status);
  }

  isExpiringSoon(test: SafetyTest): boolean {
    return this.safetyTestService.isExpiringSoon(test);
  }

  getDaysUntilExpiration(test: SafetyTest): number {
    return this.safetyTestService.getDaysUntilExpiration(test);
  }
}
